import { FormType, isConditionalLogicEnabledForFormType } from '@gearbelt/global';

import { useFeatureFlag } from '@/hooks/use-feature-flag';

export const useConditionalLogicEnabled = (formType: FormType): boolean => {
  const enableConditionalLogic = useFeatureFlag('enableConditionalLogic');
  return isConditionalLogicEnabledForFormType(formType, { enableConditionalLogic });
};
